<template>
    <div class="form-sign-in">
        <div class="text-center" v-if="loading === true">
            <loading/>
            <span class="d-block mt-2">{{t('Verifying your account')}}</span>
        </div>
        <div v-if="loading === false">
            <slot name="before-form"></slot>
            <ul class="available-users list-group" v-if="showAvailableUsers">
              <li
                v-for="user in getAvailableUsers"
                class="available-user list-group-item"
                v-bind:class="{ active: pickedUserId === user.get('id'),inactive: pickedUserId !== user.get('id') }"
                @click="pickUser(user)"
              >
                <img src="/static/avatar.svg" style="margin-right:10px; width: 50px;height: 50px; float:left;" />
                <div class="remove" @click="removeUser(user)">
                  <font-awesome-icon icon="times" />
                </div>
                <div style="float:left; width:70%;">{{user.get('fullName')}}</div>
                <div style="font-size:14px; color: gray; float:left; width:70%;">{{user.get('login')}}</div>
              </li>
            </ul>
            <titan-form ref="loginForm"
                        :schema="schema"
                        :renderInCard="false"
                        :model="formData"
                        @saveData="sendForm()"
            />
            <div class="d-block link-row" v-if="forgotPasswordLink !== null || registrationLink !== null">
                <router-link :to="registrationLink" v-if="registrationLink !== null">
                    {{t(registrationLabel)}}
                </router-link>
                <router-link :to="forgotPasswordLink" v-if="forgotPasswordLink !== null" class="float-right">
                    {{t(forgotPasswordLabel)}}
                </router-link>
            </div>
            <button type="button" class="btn btn-primary btn-block" @click="sendForm()">
                {{t('LogIn')}}
            </button>
            <slot name="after-form"></slot>
        </div>
    </div>
</template>
<script>
    import TitanForm from '../../Form/Form'
    import VueFormGenerator from "vue-form-generator";
    import Loading from '../loading';

    export default {
        components: {
            Loading,
            TitanForm
        },
        props: {
            registrationLink: {
                default: null,
            },
            registrationLabel: {
                type: String,
                default: 'Registration',
            },
            forgotPasswordLink: {
                default: null,
            },
            forgotPasswordLabel: {
                type: String,
                default: 'Forgot password?',
            },
            login: {
                type: Function,
                required: true,
            },
            userStore: {
                type: Object,
                required: false
            }
        },
        methods: {
            removeUser(user) {
                user.remove();
            },
            pickUser(user) {
                this.pickedUserId = user.get('id');
                this.formData.login = user.get('login');
            },
            sendForm() {
                if (this.$refs.loginForm.isValid() === true) {
                    this.loading = true;
                    this.login(this.formData).then(response => {
                        this.loading = false;
                        this.$emit('loggedIn');
                    }).catch(error => {
                        this.loading = false;
                        this.$emit('failedToLogin', error);
                    });
                }
            },
        },
        data() {
            return {
                pickedUserId:0,
                loading: false,
                schema: [
                    {
                        name: '',
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Login'),
                                model: 'login',
                                required: true,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('Password'),
                                model: 'password',
                                required: true,
                                validator: VueFormGenerator.validators.string
                            }
                        ]
                    }
                ],
                formData: {
                    login: '',
                    password: '',
                }
            }
        },
        computed: {
            showAvailableUsers() {
                if(this.userStore) {
                    return true;
                }
            },
            getAvailableUsers() {
                return this.userStore.getAll();
            },
        }
    }
</script>
<style lang="scss">
    .form-sign-in {
        .available-users {
          padding: 0;
          cursor: pointer;
          margin-bottom: 1rem;
          .available-user {
            padding:0.6rem 0.25rem;
            border-width: 0 0 1px 0;
            border-radius: 0;
            &:last-child {
               border-width: 0;
            }
            &.inactive:hover {
              background: #dadada;
              color:black;
            }
            .remove {
              color: gray;
              position:absolute;
              top: 5px;
              right: 10px;
              :hover {
                color:black;
              }
            }
            &.active > div {
               color:white !important;
            }
          }
        }

        .titan-form-block {
            margin-bottom: 0;
        }

        .link-row {
            margin-top: -5px;
            margin-bottom: 15px;

            a {
                color: #8e8e8e;
                font-size: 15px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/core/Components/User/Login.vue